import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import PathFormLayout from './containers/Form';
import PathsGridLayout from './containers/Grid';

export default function PathLayout() {
  return (
    <Router>
      <PrivateRoute exact path="/path/paths" component={PathsGridLayout} />
      <PrivateRoute path={["/path/paths/add", "/path/paths/:id"]} component={PathFormLayout} />
    </Router>
  );
}

